export const communicationStatuses = Object.freeze(['draft', 'queued', 'sent', 'delivered', 'failed', 'unknown'])

export function prepareCommunication({ channel, body, consent }: { channel: 'call' | 'email' | 'sms'; body: string; consent: boolean }) {
  if (!['call', 'email', 'sms'].includes(channel)) throw new Error('unsupported_channel')
  if (typeof body !== 'string' || !body.trim()) throw new Error('message_required')
  if ((channel === 'email' || channel === 'sms') && consent !== true) throw new Error('consent_required')
  return {
    channel,
    status: 'draft',
    summary: 'Draft prepared locally. No provider request was made.',
    writesPerformed: false,
  }
}

export function recordLifecycleOutcome({ disposition, nextAction, dueAt }: { disposition: string; nextAction: string; dueAt: string }) {
  if (typeof disposition !== 'string' || !disposition.trim()) throw new Error('disposition_required')
  if (typeof nextAction !== 'string' || !nextAction.trim()) throw new Error('next_action_required')
  if (typeof dueAt !== 'string' || !dueAt.trim()) throw new Error('due_at_required')
  return {
    status: 'local-preview',
    disposition: disposition.trim(),
    nextAction: nextAction.trim(),
    dueAt,
    writesPerformed: false,
  }
}

export function createGuidedSignupHandoff({ contactId, organizationId }: { contactId: string; organizationId: string }) {
  if (!contactId || !organizationId) throw new Error('bounded_customer_context_required')
  return {
    contactId,
    organizationId,
    status: 'prepared-not-submitted',
    owner: 'Owner App',
    note: 'CRM prepares context only; Owner App remains authoritative for signup and activation.',
    writesPerformed: false,
  }
}
